(() => {
  'use strict';

  const ICONS = Object.freeze({
    A: ['https://cdn.shopify.com/s/files/1/0766/4051/8479/files/A.svg?v=1699963582', 54, 28],
    B: ['https://cdn.shopify.com/s/files/1/0766/4051/8479/files/B.svg?v=1699963582', 54, 28],
    C: ['https://cdn.shopify.com/s/files/1/0766/4051/8479/files/C.svg?v=1699963582', 54, 28],
    D: ['https://cdn.shopify.com/s/files/1/0766/4051/8479/files/D.svg?v=1699963582', 54, 28],
    E: ['https://cdn.shopify.com/s/files/1/0766/4051/8479/files/E.svg?v=1699963582', 54, 28],
    F: ['https://cdn.shopify.com/s/files/1/0766/4051/8479/files/F.svg?v=1699963582', 54, 28],
    G: ['https://cdn.shopify.com/s/files/1/0766/4051/8479/files/G.svg?v=1699963582', 54, 28],
    'A+': ['https://cdn.shopify.com/s/files/1/0766/4051/8479/files/a-plus.webp?v=1726130082', 240, 97],
    'A++': ['https://cdn.shopify.com/s/files/1/0766/4051/8479/files/aplusplus.webp?v=1726130101', 240, 97],
    'A+++': ['https://cdn.shopify.com/s/files/1/0766/4051/8479/files/aplusplusplus.webp?v=1726130119', 240, 97]
  });

  const SPEC_LABELS = new Set(['breedte', 'capaciteit', 'geluid', 'energielabel', 'energieklasse']);
  const WHY_RE = /^waarom\s+deze\s+keuze\??$/i;
  const PRODUCT_BUTTON_RE = /^(bekijk\s+(?:product|vaatwasser|wasmachine)|meer\s+informatie)$/i;
  let scheduled = false;

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function isLeafTextElement(element) {
    if (!(element instanceof Element)) return false;
    const ownText = cleanText(element.textContent);
    if (!ownText) return false;
    return !Array.from(element.children).some((child) => cleanText(child.textContent) === ownText);
  }

  function normaliseEnergy(value) {
    const compact = cleanText(value)
      .toUpperCase()
      .replace(/ENERGIEKLASSE|ENERGIELABEL/g, '')
      .replace(/[^A-G+]/g, '');

    return /^(?:A\+{1,3}|[A-G])$/.test(compact) ? compact : '';
  }

  function createEnergyIcon(energyClass) {
    const icon = ICONS[energyClass];
    if (!icon) return null;

    const image = document.createElement('img');
    image.className = 'pw-energy-label-icon pw-energy-label-icon--advisor';
    image.src = icon[0];
    image.width = icon[1];
    image.height = icon[2];
    image.alt = `Energielabel ${energyClass}`;
    image.loading = 'lazy';
    image.decoding = 'async';
    image.style.setProperty('display', 'block', 'important');
    image.style.setProperty('width', 'auto', 'important');
    image.style.setProperty('height', 'auto', 'important');
    image.style.setProperty('max-width', energyClass.includes('+') ? '64px' : '54px', 'important');
    image.style.setProperty('max-height', '30px', 'important');
    image.style.setProperty('margin', '6px auto 0', 'important');
    image.style.setProperty('object-fit', 'contain', 'important');
    return image;
  }

  function candidateLeafElements(scope) {
    return Array.from(scope.querySelectorAll('small, span, p, strong, b, div, dt, dd, h2, h3, h4, h5, h6'))
      .filter(isLeafTextElement);
  }

  function findSpecCell(label) {
    let current = label.parentElement;

    for (let depth = 0; current && depth < 5; depth += 1, current = current.parentElement) {
      const energyClass = normaliseEnergy(current.textContent);
      const directLabels = candidateLeafElements(current)
        .filter((element) => SPEC_LABELS.has(cleanText(element.textContent).toLowerCase()));

      if (energyClass && directLabels.length === 1) return current;
    }

    return label.parentElement;
  }

  function replaceEnergyValue(cell, label) {
    if (!(cell instanceof Element) || cell.dataset.pwEnergyFixed === 'true') return;

    const energyClass = normaliseEnergy(cell.textContent);
    if (!energyClass) return;

    const image = createEnergyIcon(energyClass);
    if (!image) return;

    const valueElement = candidateLeafElements(cell).find((element) => {
      if (element === label || label.contains(element) || element.contains(label)) return false;
      return normaliseEnergy(element.textContent) === energyClass;
    });

    if (valueElement) {
      valueElement.replaceWith(image);
    } else {
      const walker = document.createTreeWalker(cell, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);

      const valueTextNode = textNodes.find((node) => {
        if (label.contains(node.parentElement)) return false;
        return normaliseEnergy(node.nodeValue) === energyClass;
      });

      if (valueTextNode) {
        valueTextNode.nodeValue = '';
      }
      cell.appendChild(image);
    }

    cell.dataset.pwEnergyFixed = 'true';
    cell.style.setProperty('height', 'auto', 'important');
    cell.style.setProperty('min-height', '0', 'important');
    cell.style.setProperty('overflow', 'visible', 'important');
  }

  function closestCard(node) {
    let current = node instanceof Element ? node : node?.parentElement;

    for (let depth = 0; current && depth < 10; depth += 1, current = current.parentElement) {
      const text = cleanText(current.textContent).toLowerCase();
      const hasWhy = text.includes('waarom deze keuze');
      const hasProductLink = Boolean(current.querySelector('a[href*="/products/"]'));
      const hasButton = candidateLeafElements(current).some((element) => PRODUCT_BUTTON_RE.test(cleanText(element.textContent)));
      const hasMultipleSpecs = candidateLeafElements(current)
        .filter((element) => SPEC_LABELS.has(cleanText(element.textContent).toLowerCase())).length >= 3;

      if (hasWhy && hasMultipleSpecs && (hasProductLink || hasButton)) return current;
    }

    return null;
  }

  function findSpecGrid(card) {
    const labels = candidateLeafElements(card)
      .filter((element) => SPEC_LABELS.has(cleanText(element.textContent).toLowerCase()));

    if (labels.length < 2) return null;

    let current = labels[0].parentElement;
    while (current && current !== card) {
      const count = labels.filter((label) => current.contains(label)).length;
      if (count >= Math.min(3, labels.length)) {
        const childAlsoContainsAll = Array.from(current.children).some((child) => {
          return labels.filter((label) => child.contains(label)).length >= Math.min(3, labels.length);
        });
        if (!childAlsoContainsAll) return current;
      }
      current = current.parentElement;
    }

    return null;
  }

  function findProductTitle(card, specGrid) {
    const links = Array.from(card.querySelectorAll('a[href*="/products/"]'))
      .filter((link) => {
        const text = cleanText(link.textContent);
        if (text.length < 8 || PRODUCT_BUTTON_RE.test(text)) return false;
        if (link.querySelector('img')) return false;
        if (specGrid && !(link.compareDocumentPosition(specGrid) & Node.DOCUMENT_POSITION_FOLLOWING)) return false;
        return true;
      });

    if (links.length) return links[0];

    const headings = Array.from(card.querySelectorAll('h2, h3, h4, h5, h6'))
      .filter((heading) => {
        const text = cleanText(heading.textContent);
        if (text.length < 8 || WHY_RE.test(text)) return false;
        if (specGrid && !(heading.compareDocumentPosition(specGrid) & Node.DOCUMENT_POSITION_FOLLOWING)) return false;
        return true;
      });

    return headings[0] || null;
  }

  function unlockElement(element, options = {}) {
    if (!(element instanceof HTMLElement)) return;

    element.style.setProperty('height', 'auto', 'important');
    element.style.setProperty('min-height', '0', 'important');
    element.style.setProperty('max-height', 'none', 'important');
    element.style.setProperty('overflow', 'visible', 'important');
    element.style.setProperty('overflow-x', 'visible', 'important');
    element.style.setProperty('overflow-y', 'visible', 'important');

    if (options.staticPosition) {
      element.style.setProperty('position', 'static', 'important');
      element.style.setProperty('inset', 'auto', 'important');
      element.style.setProperty('transform', 'none', 'important');
    }

    const computed = window.getComputedStyle(element);
    if (computed.display.includes('grid')) {
      element.style.setProperty('grid-template-rows', 'none', 'important');
      element.style.setProperty('grid-auto-rows', 'auto', 'important');
    }
  }

  function fixCardLayout(card) {
    if (!(card instanceof HTMLElement)) return;

    const specGrid = findSpecGrid(card);
    const title = findProductTitle(card, specGrid);
    if (!title || !specGrid) return;

    card.dataset.pwAdvisorCardFixed = 'true';
    card.style.setProperty('height', 'auto', 'important');
    card.style.setProperty('min-height', '0', 'important');
    card.style.setProperty('max-height', 'none', 'important');

    const titleBox = title.closest('h2, h3, h4, h5, h6') || title.parentElement || title;
    [title, titleBox].forEach((element) => {
      unlockElement(element, { staticPosition: true });
      element.style.setProperty('display', 'block', 'important');
      element.style.setProperty('width', '100%', 'important');
      element.style.setProperty('white-space', 'normal', 'important');
      element.style.setProperty('text-overflow', 'clip', 'important');
      element.style.setProperty('word-break', 'normal', 'important');
      element.style.setProperty('overflow-wrap', 'anywhere', 'important');
      element.style.setProperty('-webkit-line-clamp', 'unset', 'important');
      element.style.setProperty('line-clamp', 'unset', 'important');
      element.style.setProperty('-webkit-box-orient', 'initial', 'important');
    });
    titleBox.style.setProperty('margin-bottom', '20px', 'important');

    unlockElement(specGrid, { staticPosition: true });
    specGrid.style.setProperty('width', '100%', 'important');
    specGrid.style.setProperty('clear', 'both', 'important');
    specGrid.style.setProperty('flex', 'none', 'important');
    specGrid.style.setProperty('margin-top', '0', 'important');

    let current = titleBox.parentElement;
    while (current && current !== card) {
      unlockElement(current);
      current = current.parentElement;
    }

    const whyElement = candidateLeafElements(card).find((element) => WHY_RE.test(cleanText(element.textContent)));
    if (whyElement) {
      let whyContainer = whyElement.parentElement;
      for (let depth = 0; whyContainer && whyContainer !== card && depth < 3; depth += 1, whyContainer = whyContainer.parentElement) {
        unlockElement(whyContainer, { staticPosition: true });
      }
    }
  }

  function enhance(scope = document) {
    const leaves = candidateLeafElements(scope);

    leaves
      .filter((element) => /^energielabel$/i.test(cleanText(element.textContent)) || /^energieklasse$/i.test(cleanText(element.textContent)))
      .forEach((label) => replaceEnergyValue(findSpecCell(label), label));

    leaves
      .filter((element) => WHY_RE.test(cleanText(element.textContent)))
      .map(closestCard)
      .filter(Boolean)
      .forEach(fixCardLayout);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      enhance();
    });
  }

  function init() {
    enhance();

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length > 0 || mutation.type === 'characterData')) {
        schedule();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
